import { Grid, GridProps, MantineSize } from "@mantine/core"
import React, { ReactNode } from "react"

type EqualWidthGridProps = {
  children: ReactNode
  spacing?: string | MantineSize
} & GridProps
export const EqualWidthGrid = ({
  children,
  spacing = "xs",
}: EqualWidthGridProps) => {
  const childCount = React.Children.count(children)
  const columnSpan = childCount > 0 ? 12 / childCount : 12
  const typeSafeChildren: ReactNode[] = React.Children.toArray(children)

  return (
    <Grid gutter={spacing} w="100%" grow>
      {React.Children.map(typeSafeChildren, (child) => (
        <Grid.Col span={columnSpan}>{child}</Grid.Col>
      ))}
    </Grid>
  )
}
